export default (function (origin) {
    switch (origin) {
        case 'bottom-center':
            return { vertical: 'bottom', horizontal: 'center' };
        case 'center-left':
            return { vertical: 'center', horizontal: 'left' };
        case 'center-right':
            return { vertical: 'center', horizontal: 'right' };
        case 'center-center':
            return { vertical: 'center', horizontal: 'center' };
        case 'top-right':
            return { vertical: 'top', horizontal: 'right' };
        case 'bottom-left':
            return { vertical: 'bottom', horizontal: 'left' };
        case 'bottom-right':
            return { vertical: 'bottom', horizontal: 'right' };
        case 'top-left':
            return { vertical: 'top', horizontal: 'left' };
        case 'top-center':
        default:
            return { vertical: 'top', horizontal: 'center' };
    }
});
